import { isOverdue } from "./taskDates";

export const PINNED_TRIAGE_VIEWS = [
    { id: "unassigned", label: "Unassigned" },
    { id: "overdue", label: "Overdue" },
    { id: "high", label: "High" },
    { id: "nodue", label: "No due" },
];

export function isTaskActive(task) {
    return String(task?.status || "") !== "Completed";
}

export function isUnassigned(task) {
    const value = task?.assign_to;
    return value == null || value === "" || value === "unassigned" || value === 0 || value === "0";
}

export function hasNoDueDate(task) {
    return isTaskActive(task) && !task?.due_date;
}

export function isHighPriority(task) {
    return isTaskActive(task) && String(task?.priority || "").toLowerCase() === "high";
}

export function matchesTriagePin(task, pinId) {
    if (!isTaskActive(task)) return false;
    if (pinId === "unassigned") return isUnassigned(task);
    if (pinId === "overdue") return isOverdue(task);
    if (pinId === "high") return isHighPriority(task);
    if (pinId === "nodue") return hasNoDueDate(task);
    return false;
}

export function triageCounts(tasks = []) {
    const counts = { unassigned: 0, overdue: 0, high: 0, nodue: 0 };
    for (const task of tasks) {
        for (const pin of PINNED_TRIAGE_VIEWS) {
            if (matchesTriagePin(task, pin.id)) counts[pin.id] += 1;
        }
    }
    return counts;
}

export function tasksForTriagePin(tasks = [], pinId) {
    return tasks.filter((task) => matchesTriagePin(task, pinId));
}
